import React from "react";
import { FormGroup } from "react-bootstrap";
import { Field } from "react-final-form";
import { Error } from "../Conditionals/Error";

export const InputField = ( props ) => {
    const {
        fieldId,
        fieldLabel,
        fieldDefaultValue,
        fieldType,
        fieldRequired,
        fieldMin,
        fieldMax,
        hint,
        placeholder,
        validator
    } = props
    return <Field name={ fieldLabel } validate={ validator }>
        { ( { input, meta } ) => (
            <FormGroup
                className={ ((meta.error || input.value === "") ? "has-error " : " ") + (!meta.error && (meta.modified || meta.touched) ? "is-success " : " ") }>
                <div className="text">
                    <label htmlFor={ fieldId }>{ fieldLabel }
                        { (meta.error || input.value === "") &&
                        <Error name={ fieldLabel }>{ meta.error }</Error> }
                    </label>
                    { hint && <p>
                        { hint }
                    </p> }
                    <input
                        { ...input }
                        id={ fieldId }
                        type={ fieldType }
                        defaultValue={ input.value ? input.value : fieldDefaultValue }
                        placeholder={ placeholder || "" }
                        className={ "form-control" }
                        min={ fieldMin || null }
                        max={ fieldMax || null }
                        required={ fieldRequired }
                    />
                </div>
            </FormGroup>
        ) }
    </Field>;
}
